import { Checkbox, Dropdown, Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import ReImportButton from 'Components/Worksheets/Core/ReImportButton';
import { ISieveSize } from 'Data/ViewModels/Equipment/ISieveSize';
import { hasValue, valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';

let PreparationSectionBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const needsWarming = useSelector(pipe(createWorksheetSelector!('SampleWarming'), valueOrDefault(false)));
  const asphaltMixSizeImported = useSelector(pipe(createWorksheetSelector!('MixMaximumParticleSize'), hasValue));
  const availableSieveSizes: ISieveSize[] = useSelector(createWorksheetSelector!('AvailableSieveSizes'));

  const sieveSizeOptions = availableSieveSizes?.map((s) => ({ value: s.Id, label: s.Caption }));
  return (
    <>
      <ListFieldSection>
        <FieldSet>
          <Field
            input={<Dropdown />}
            label="Mix Maximum Particle Size (mm)"
            name="SieveSizeId"
            options={sieveSizeOptions}
            simpleValue
            isClearable={false}
            visible={!asphaltMixSizeImported}
          />
          <Field input={<TextOutput />} name="MixMaximumParticleSize" visible={asphaltMixSizeImported} />
          <ReImportButton name="ImportedMixMaximumParticleSizeSource" />
          <Field input={<Checkbox />} name="ContainsMoistureOrVolatileOils" />
        </FieldSet>
        <FieldSet>
          <Field input={<Checkbox />} name="SampleWarming" />
          <Field
            input={<WorksheetEquipmentDropdown />}
            equipmentType="oven"
            label="Oven"
            name="Oven"
            visible={needsWarming}
          />
        </FieldSet>
      </ListFieldSection>
    </>
  );
};

const PreparationSection = withInjectedProps(PreparationSectionBase);

export { PreparationSection };
export default PreparationSection;
